const bigInt = require('big-integer');
const crypto = require('crypto');

const calcTestVariant = (identifier, variantsVector) => {
  const shasum = crypto.createHash('sha1');
  shasum.update(identifier);
  const hexHash = shasum.digest('hex');
  const hexNum = bigInt(hexHash, 16);
  const modulo = parseInt(hexNum.divmod(variantsVector.length).remainder);

  return variantsVector[modulo];
};

const selectVariantName = (experimentName, userId, variantsVector) => {
  if (!userId) return '';
  const uniqueString = `${experimentName}::${userId}`;
  const variantName = calcTestVariant(uniqueString, variantsVector);
  return variantName;
};

module.exports = selectVariantName;
